import { FormikErrors } from 'formik'

import { handleResult } from 'modules/core/lib/handleMutation'

import useCreateReimbursableSupplementMapping from 'modules/payroll_bundle/hooks/useCreateReimbursableSupplementMapping'
import useUpdateReimbursableSupplementMapping from 'modules/payroll_bundle/hooks/useUpdateReimbursableSupplementMapping'

import {
  CustomTimeRangesFormData,
  ReimbursableTaxonomiesMappingForm,
} from './CustomTimeRangesFormData'

const useHandleReumbursableMappings = () => {
  const { create: createMapping } = useCreateReimbursableSupplementMapping()
  const { update: updateMapping } = useUpdateReimbursableSupplementMapping()

  const manageMappings = async (
    setErrors: (errors: FormikErrors<CustomTimeRangesFormData>) => void,
    mappings: ReimbursableTaxonomiesMappingForm[]
  ) =>
    await Promise.all(
      mappings.map(async (mapping) => {
        if (mapping.id) {
          const response = await updateMapping({
            id: mapping.id,
            supplementTaxonomyId: mapping.supplementTaxonomyId,
          })
          handleResult(response, setErrors)
        } else {
          const response = await createMapping({
            legalEntityId: mapping.legalEntityId.toString(),
            reimbursableId: mapping.timeRangeCategoryId.toString(),
            reimbursableType: 'TimeSettings::CustomTimeRangeCategory',
            supplementTaxonomyId: mapping.supplementTaxonomyId,
          })
          handleResult(response, setErrors)
        }
      })
    )

  return { manageMappings }
}

export default useHandleReumbursableMappings
